/**
 * Exports
*/

export const TOKEN_NAME = 'BearerToken';
export const TOKEN_TYPE = 'Bearer';